import React from "react";
import { MASTERS_ROUND_PAR } from "../espnRoundDetails";
import { recentHoleChipClass, scoreChipKind } from "../holeScoreChipStyles";

function roundGrossChipClass(score, tone) {
    const base =
        "inline-flex shrink-0 items-center justify-center rounded px-2 py-0.5 text-[11px] font-semibold tabular-nums leading-none";
    if (score < MASTERS_ROUND_PAR) {
        return `${base} bg-red-600 text-white`;
    }
    if (score > MASTERS_ROUND_PAR) {
        return `${base} bg-black text-white`;
    }
    return tone === "dark"
        ? `${base} bg-neutral-500 text-white`
        : `${base} bg-neutral-400 text-masters-forest`;
}

export function PickRoundMeta({
    thru,
    roundGrossStrokes,
    recentVsPar,
    className = "",
    tone = "card",
}) {
    const hasForm = Array.isArray(recentVsPar) && recentVsPar.length > 0;
    const hasGross =
        typeof roundGrossStrokes === "number" &&
        !Number.isNaN(roundGrossStrokes);
    if (!thru && !hasForm && !hasGross) return null;
    const thruClass =
        tone === "dark"
            ? "text-[11px] font-normal text-masters-goldmuted/95"
            : "text-[11px] font-normal text-masters-goldmuted";
    const formClass =
        tone === "dark"
            ? "text-[11px] font-medium tabular-nums leading-snug text-masters-cream/85"
            : "text-[11px] font-medium tabular-nums leading-snug text-masters-forest/90";
    return (
        <div
            className={`flex flex-wrap items-center gap-x-3 ${className}`.trim()}
        >
            {hasGross ? (
                <span
                    className={`shrink-0 ${roundGrossChipClass(roundGrossStrokes, tone)}`}
                >
                    {roundGrossStrokes}
                </span>
            ) : thru ? (
                <span className={`shrink-0 ${thruClass}`}>{thru}</span>
            ) : null}
            {hasForm ? (
                <div
                    className={`flex flex-wrap items-center gap-x-2 gap-y-1 ${formClass}`}
                >
                    {recentVsPar.map((token, i) => {
                        const kind = scoreChipKind(token);
                        const chip = recentHoleChipClass(kind, tone);
                        return (
                            <span
                                key={i}
                                className={chip || undefined}
                            >
                                {token}
                            </span>
                        );
                    })}
                </div>
            ) : null}
        </div>
    );
}
